import React, { useEffect } from "react";
import ProtectionSuccessImg from "../../assets/img/protectionsuccess.png";
import ProtectionFailureImg from "../../assets/img/protectionfailure.png";
import Translation from "../../services/translation.service";
import Settings from "../../services/settings.service";
import Storage from "../../services/storage.service";

export default function ProtectionChannelStatus({
  setStepDetails = () => {},
  setActiveScreen = () => {},
  status = "",
  history = {},
}) {
  let prefix = "scr_protection_channel";

  useEffect(() => {
    if(status === "success") {
      handleRedirectSurvey();
    } 
  },[status]) // eslint-disable-line react-hooks/exhaustive-deps

  const homeRedirect = () => {
    clearStorage();
    window.location.href =
      Settings.get("site_link") + Translation.activeLang + "/";
    // let a = Settings.get('site_link') + Translation.activeLang + "/
  };

  const contactUsRedirect = () => {
    clearStorage();
    let contact_us_link = Settings.get("contact_us");
    contact_us_link = contact_us_link.replace("%lang%", Translation.activeLang);
    window.location.href = contact_us_link;
    // let a = Settings.get('site_link') + Translation.activeLang + "/
  };

  const clearStorage = () => {
    window.localStorage.removeItem("protection_channel_redirect");
    window.localStorage.removeItem("protection_channel_redirect_url");
    window.localStorage.removeItem("protection_channel_step");
    Storage.clear("reportErrorStatus", true, true);
    Storage.clear("reportOtpError", true, true);
  };

  const tryhandling = () => {
    Storage.clear("reportErrorStatus", true, true);
    Storage.clear("reportOtpError", true, true);
    setStepDetails({
      step1: { status: "isDone" },
      step2: { status: "inProgress" },
      step3: { status: "notVisited" },
    });
    setActiveScreen("ReasonScreen");
  };

  const handleRedirectSurvey = () => {
    // this added so survey330 data is reset when user clicks on take me to the survey
    sessionStorage.removeItem("survey_step");
    sessionStorage.removeItem("survey_rating");
    sessionStorage.removeItem("survey_feedback");
    sessionStorage.removeItem("survey_outcome_type");
    history.push({
      pathname: "/page/protection-channel-survey",
    });
    Storage.set(
      "survey330_form_origin",
      "FromProtectionChannelSurveySuccess",
      true
    );
  };

  return (
    <div className="protection-channel-status-screen">
      {status === "success" && (
        <div className={status}>
          <img src={ProtectionSuccessImg} alt="" />
          <span>
            {Translation.keys[prefix + "_report_submitted_successfully"]}
          </span>
          <button
            className="common-button survey-button"
            onClick={handleRedirectSurvey}
          >
            {Translation.keys["scr_protection_channel_take_me_to_survey"]}
          </button>
          <button
            className="common-button-light"
            onClick={() => {
              homeRedirect();
            }}
          >
            {Translation.keys[prefix + "_go_to_home_page"]}
          </button>
        </div>
      )}
      {status === "failure" && (
        <div className={status}>
          <img src={ProtectionFailureImg} alt="" />
          <span>
            {Translation.keys[prefix + "_sorry_something_went_wrong"]}
          </span>
          <div>
            <button
              className="common-button failure-button"
              onClick={() => {
                tryhandling();
              }}
            >
              {Translation.keys[prefix + "_go_back_tryagain"]}
            </button>
            <button
              className="common-button-light"
              onClick={() => {
                contactUsRedirect();
              }}
            >
              {Translation.keys[prefix + "_contact_us"]}
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
